import { render, staticRenderFns } from "./MLFFIntroduce.vue?vue&type=template&id=3f89991e&scoped=true&"
import script from "./MLFFIntroduce.vue?vue&type=script&lang=js&"
export * from "./MLFFIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./MLFFIntroduce.vue?vue&type=style&index=0&id=3f89991e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89991e",
  null
  
)

export default component.exports